import { render } from "./buttonsLayout.vue?vue&type=template&id=f0269676"
import script from "./buttonsLayout.vue?vue&type=script&lang=js"
export * from "./buttonsLayout.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\catalogo\\catalogo-pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__